export enum PractitionersExportColumns {
    bankAccountNumber = 'bankAccountNumber',
    bankAccountStatus = 'bankAccountStatus',
    bankAccountSubscriber = 'bankAccountSubscriber',
    emailAddress = 'emailAddress',
    employments = 'employments',
    financialEmailAddress = 'financialEmailAddress',
    id = 'id',
    identifierDeclaration = 'identifierDeclaration',
    identifierRegistrationBig = 'identifierRegistrationBig',
    identifierRegistrationKp = 'identifierRegistrationKp',
    isActivated = 'isActivated',
    lastActivityDate = 'lastActivityDate',
    mobileNumber = 'mobileNumber',
    name = 'name',
    organizations = 'organizations',
    relationNumber = 'relationNumber',
    service = 'service',
    zorgmailNummer = 'zorgmailNummer',
}
